import { FC, PropsWithChildren } from 'react';
import { ChevronsDown, ChevronsUp } from 'react-feather';
import { FormattedMessage, type IntlShape } from 'react-intl';
import { Button, FormGroup, Input, Label } from 'reactstrap';

interface Props {
  toggleId: string;
  showPrivateComments: boolean;
  onToggleShowPrivate: (value: boolean) => void;
  allThreadsExpanded: boolean;
  onToggleExpandCollapse: () => void;
  formatMessage: IntlShape['formatMessage'];
}

const ThreadedCommentFilters: FC<PropsWithChildren<Props>> = ({
  toggleId,
  showPrivateComments,
  onToggleShowPrivate,
  allThreadsExpanded,
  onToggleExpandCollapse,
  formatMessage,
  children,
}) => {
  return (
    <div className="d-flex flex-wrap align-items-center gap-3 mb-3">
      <Button
        color="link"
        size="sm"
        className="px-0 d-inline-flex align-items-center gap-1"
        onClick={onToggleExpandCollapse}
      >
        {allThreadsExpanded ? (
          <ChevronsUp size={16} />
        ) : (
          <ChevronsDown size={16} />
        )}
        {allThreadsExpanded
          ? formatMessage({
              id: 'app.views.widgets.comments.threaded_comment_filters.collapse',
              defaultMessage: 'Collapse all',
            })
          : formatMessage({
              id: 'app.views.widgets.comments.threaded_comment_filters.expand',
              defaultMessage: 'Expand all',
            })}
      </Button>
      <FormGroup
        switch
        className="mb-0 d-flex align-items-center gap-2 text-nowrap"
      >
        <Input
          type="switch"
          id={toggleId}
          checked={showPrivateComments}
          onChange={(event) => onToggleShowPrivate(event.target.checked)}
        />
        <Label check htmlFor={toggleId} className="small mb-0">
          <FormattedMessage
            id="app.views.widgets.comments.threaded_comment_filters.show_private"
            defaultMessage="Show private comments"
          />
        </Label>
      </FormGroup>
      {children && (
        <div className="ms-auto d-inline-flex align-items-center gap-2 text-nowrap">
          {children}
        </div>
      )}
    </div>
  );
};

export default ThreadedCommentFilters;
